"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
jquery_1.default.event.special.touchstart = {
    setup: function (_, ns, handle) {
        if ((ns.indexOf('noPreventDefault') > -1)) {
            this.addEventListener("touchstart", handle, { passive: false });
        }
        else {
            this.addEventListener("touchstart", handle, { passive: true });
        }
    }
};
jquery_1.default.event.special.touchmove = {
    setup: function (_, ns, handle) {
        if ((ns.indexOf('noPreventDefault') > -1)) {
            this.addEventListener("touchmove", handle, { passive: false });
        }
        else {
            this.addEventListener("touchmove", handle, { passive: true });
        }
    }
};
jquery_1.default.event.special.wheel = {
    setup: function (_, ns, handle) {
        if ((ns.indexOf('noPreventDefault') > -1)) {
            this.addEventListener("wheel", handle, { passive: false });
        }
        else {
            this.addEventListener("wheel", handle, { passive: true });
        }
    }
};
jquery_1.default.event.special.mousewheel = {
    setup: function (_, ns, handle) {
        if ((ns.indexOf('noPreventDefault') > -1)) {
            this.addEventListener("mousewheel", handle, { passive: false });
        }
        else {
            this.addEventListener("mousewheel", handle, { passive: true });
        }
    }
};
